// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function NotificationCount(props) {
  let count = props.count;
  if (count > 0) {
    return JsxRuntime.jsx("span", {
      children: count.toString(),
      className: TailwindMerge.twMerge([
        "absolute -top-[5px] -right-[8px] w-[19px] h-[19px] block z-[1] font-medium text-white text-center text-[13px] leading-[15px] p-[2px] rounded-full",
        props.isOpened ? "bg-tan-blue-500" : "bg-tan-gold-light",
        props.animate ? "animate-tan-notification-pulse" : ""
      ])
    });
  } else {
    return null;
  }
}

let make = NotificationCount;

exports.make = make;
/* tailwind-merge Not a pure module */
